(() => {
  function formatMoney(cents, format) {
    const rounded = Math.round(Number(cents) || 0);
    const whole = Math.floor(rounded / 100);
    const frac = String(rounded % 100).padStart(2, '0');
    const grouped = (separator) => String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    const values = {
      amount: grouped(',') + '.' + frac,
      amount_no_decimals: grouped(','),
      amount_with_comma_separator: grouped('.') + ',' + frac,
      amount_no_decimals_with_comma_separator: grouped('.'),
      amount_with_apostrophe_separator: grouped("'") + '.' + frac,
      amount_no_decimals_with_apostrophe_separator: grouped("'"),
      amount_with_space_separator: grouped(' ') + ',' + frac,
      amount_no_decimals_with_space_separator: grouped(' '),
    };
    return (format || '₺{{amount}}').replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/g, (match, key) => (
      Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
    ));
  }
  function update(root) {
    if (!root) return;
    const selected = [...root.querySelectorAll('[data-guner-bundle-part]')].filter((input) => input.checked);
    const count = root.querySelector('[data-go-piece-count]');
    const total = root.querySelector('[data-guner-paid-parts-total]');
    const message = root.querySelector('[data-guner-part-selection-message]');
    if (count) count.textContent = selected.length ? selected.length + ' ' + root.dataset.piecesLabel : root.dataset.pickLabel;
    if (total) {
      total.hidden = selected.length === 0;
      if (selected.length) {
        const cents = Number(root.dataset.basePrice || 0) + selected.reduce((sum, input) => sum + Number(input.dataset.priceCents || 0), 0);
        total.textContent = formatMoney(cents, root.dataset.moneyFormat);
      }
    }
    if (message) message.hidden = true;
  }
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof Element) || !input.matches('[data-guner-bundle-part]')) return;
    update(input.closest('[data-guner-paid-parts]'));
  });
})();
